import { GST_STATES, resolveGstMode, resolvePlaceOfSupply, stateCodeFromGstin } from '@jira-clone/shared-types'

// The place of supply decides the tax: inside the seller's state CGST + SGST, anywhere else IGST.
// It comes from the customer's GSTIN; for a customer without one, it is the State chosen here.

interface Props {
  customerGstin: string
  /** The State field of the document ("Karnataka (29)" or ''). */
  state: string
  sellerGstin?: string
  /** GST is switched off or on reverse charge: no place of supply is needed. */
  gstApplies?: boolean
  onChange: (state: string) => void
  inputClassName: string
  labelClassName: string
  id?: string
  /** Say whether the sale is inside or outside the seller's state (needs sellerGstin). */
  showSupplyHint?: boolean
  label?: string
}

export function PlaceOfSupplyField({ customerGstin, state, sellerGstin, gstApplies = true, onChange, inputClassName, labelClassName, id = 'place-of-supply', showSupplyHint = true, label = 'Place of Supply / State' }: Props) {
  const fromGstin = stateCodeFromGstin(customerGstin) !== null
  const place = resolvePlaceOfSupply({ customerGstin, customerState: state })
  const mode = resolveGstMode({ gstEnabled: gstApplies, companyGstin: sellerGstin, customerGstin, customerState: state })
  const selected = fromGstin ? place.label : place.label || ''

  return (
    <div>
      <label htmlFor={id} className={labelClassName}>{label}</label>
      <select
        id={id}
        className={inputClassName}
        value={selected}
        disabled={fromGstin}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="">Select state…</option>
        {GST_STATES.map((s) => (
          <option key={s.code} value={s.label}>{s.label}</option>
        ))}
      </select>
      <p className="mt-1 text-[11px] text-slate-500 dark:text-slate-400">
        {fromGstin
          ? 'Taken from the customer GSTIN.'
          : gstApplies && !place.code
            ? 'Add the customer GSTIN or choose their state — needed before a document can be issued.'
            : 'Used when the customer has no GSTIN.'}
        {showSupplyHint && gstApplies && place.code && mode === 'inter' ? <strong className="ml-1 text-blue-700 dark:text-blue-300">Inter-State supply — IGST applies.</strong> : null}
        {showSupplyHint && gstApplies && place.code && mode === 'intra' ? <span className="ml-1">Same state — CGST + SGST apply.</span> : null}
      </p>
    </div>
  )
}
